import * as React from 'react';
import { motion } from 'framer-motion';
import styled from 'styled-components';

import { ANIMATIONS } from '../../utils';
import {
  CustomerQuoteCard,
  type CustomerQuoteCardProps
} from '../global/CustomerQuoteCard';
import { G2SocialProofCard } from '../global/G2SocialProofCard';

const Wrapper = styled(motion.div)`
  position: relative;
  display: flex;
  flex-grow: 1;
  width: 100%;
  margin: 0 auto;
  padding: 100px 40px;

  @media (max-width: ${({ theme }) => theme.mediaQuery.MEDIUM}) {
    padding: 60px 40px;
  }

  @media (max-width: ${({ theme }) => theme.mediaQuery.SMALL}) {
    flex-direction: column;
    padding: 60px 30px;
  }
`;

const Inner = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 30px;
  margin: 0 auto;
  max-width: ${({ theme }) => theme.maxWidth.PAGE};

  @media (max-width: ${({ theme }) => theme.mediaQuery.MEDIUM}) {
    flex-direction: column;
  }
`;

interface SocialToutProps {
  className?: string;
  customerQuotes: CustomerQuoteCardProps[];
  includeG2Proof?: boolean;
}

export const SocialTout: React.ComponentType<SocialToutProps> = React.memo(
  ({ includeG2Proof = false, customerQuotes, className }) => {
    return (
      <Wrapper {...ANIMATIONS.SimpleFadeIn} className={className}>
        <Inner>
          {includeG2Proof && <G2SocialProofCard />}
          {customerQuotes.map((item, index) => (
            <CustomerQuoteCard key={index} {...item} />
          ))}
        </Inner>
      </Wrapper>
    );
  }
);
